import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { BookOpen, Lock } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import api from '../services/api';

const ChildLoginPage = () => {
  const [username, setUsername] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await api.childLogin(username, pin);
      
      // Store child session WITHOUT profile_photo (could be old base64 or new URL)
      const { profile_photo, ...childDataWithoutPhoto } = response.child;
      
      localStorage.setItem('childUser', JSON.stringify(childDataWithoutPhoto));
      localStorage.setItem('childToken', response.access_token);
      // Set child token for API service - but DON'T store in 'access_token' to avoid parent confusion
      api.setToken(response.access_token);
      
      navigate('/child/dashboard');
    } catch (error) {
      console.error('Child login failed:', error);
      toast({
        title: 'Login Failed',
        description: 'Incorrect username or PIN. Ask your parent for help!',
        variant: 'destructive'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-100 to-blue-100 flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-8 bg-white/95 backdrop-blur-sm shadow-2xl border-0">
        <div className="text-center mb-8">
          <div className="inline-block bg-gradient-to-br from-purple-500 to-pink-500 p-4 rounded-2xl mb-4">
            <BookOpen className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-2">
            EduTracker Student Portal
          </h1>
          <p className="text-slate-600">Log in to see your work and rewards!</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Label htmlFor="username" className="text-slate-700">Username</Label>
            <Input
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Your username"
              className="mt-2 text-lg"
              required
            />
          </div>

          <div>
            <Label htmlFor="pin" className="text-slate-700">PIN</Label>
            <div className="relative mt-2">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input
                id="pin"
                type="password"
                maxLength="4"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
                placeholder="••••"
                className="pl-10 text-lg text-center tracking-widest"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-6 text-lg font-semibold"
          >
            {loading ? 'Logging in...' : "Let's Go!"}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="text-sm text-slate-500 hover:text-slate-700"
          >
            ← Back to Parent View
          </button>
        </div>
      </Card>
    </div>
  );
};

export default ChildLoginPage;